export interface Chapter {
  title: string
  page: number
}

export type ChapterKey = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11
export type Section = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export interface Answer {
  text: string
  section: Section
  topic: string
  page: number
}

export type GeneratedType = "alt-answers" | "paired"

export interface Generated {
  parent: string
  type: GeneratedType
  rationale: string
}

export type QuestionStatus = "unverified" | "verified" | "discarded"

export interface Question {
  id: string
  q: string
  answer: Answer
  otherChoices: string[]
  generated: Generated | null
  batch: string
  version: number
  updatedAt: string
  status: QuestionStatus
}

export const CHAPTERS: Record<ChapterKey, Chapter> = {
  1: { title: "Kansas Driver Licenses", page: 15 },
  2: { title: "State Laws & Rules of the Road", page: 19 },
  3: { title: "Be in Shape to Drive", page: 25 },
  4: { title: "Before You Drive", page: 29 },
  5: { title: "Basic Driving", page: 32 },
  6: { title: "Rules of the Road", page: 55 },
  7: { title: "Safe Driving Tips", page: 72 },
  8: { title: "Collisions & Emergencies", page: 78 },
  9: { title: "Sharing the Road", page: 89 },
  10: { title: "Special Driving Situations", page: 93 },
  11: { title: "Sample Exam", page: 94 },
}
